import { useAuth } from '../contexts/AuthContext.jsx';

function Header() {
  const { user, logout } = useAuth();

  return (
    <header style={{
      background: 'linear-gradient(135deg, #0a72e7 0%, #0858b4 100%)',
      color: 'white', padding: '0 24px', height: '64px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div style={{
          width: '36px', height: '36px', background: 'rgba(255,255,255,0.2)',
          borderRadius: '8px', display: 'flex', alignItems: 'center',
          justifyContent: 'center', fontWeight: '700', fontSize: '16px'
        }}>T</div>
        <h1 style={{ margin: 0, fontSize: '18px', fontWeight: '600', letterSpacing: '-0.3px' }}>
          Treads Sales Queue Stats
        </h1>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        {user && (
          <span style={{ fontSize: '14px', opacity: 0.9 }}>{user.username}</span>
        )}
        <button onClick={logout} style={{
          background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.25)',
          color: 'white', padding: '6px 16px', borderRadius: '6px', cursor: 'pointer',
          fontSize: '13px', fontWeight: '500', transition: 'all 0.2s', fontFamily: 'inherit'
        }} onMouseEnter={e => e.target.style.background = 'rgba(255,255,255,0.25)'}
        onMouseLeave={e => e.target.style.background = 'rgba(255,255,255,0.15)'}>
          Logout
        </button>
      </div>
    </header>
  );
}

export default Header;
